import { Box, Typography, Link } from "@mui/material";

const TopSegmentsCard = () => (
  <Box sx={{
    background: 'linear-gradient(135deg, #e3f2fd 0%, #f8fafc 100%)',
    borderRadius: 2,
    border: '1px solid #e3e7ed',
    boxShadow: '0 2px 8px 0 rgba(99, 99, 99, 0.1)',
    display: 'flex',
    flexDirection: 'column',
    px: 3,
    py: 2.5,
    gap: 1.5,
    height: '100%',
    fontFamily: 'Montserrat, Arial, sans-serif',
    transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
    '&:hover': {
      transform: 'scale(1.03)',
      boxShadow: '0 4px 20px 0 rgba(99, 99, 99, 0.2)',
    }
  }}>
    <Typography variant="subtitle1" sx={{ color: '#1976d2', fontWeight: 700, mb: 1 }}>
      Segments Phares
    </Typography>
    <Box>
      <Typography sx={{ fontWeight: 600, color: '#1976d2', fontSize: 15 }}>
        ● Clients Actifs
      </Typography>
      <Typography sx={{ color: '#495057', fontSize: 14 }}>
        Fidélité élevée, taux d’ouverture 34%. <br />
        <span style={{ color: '#43a047', fontWeight: 600 }}>Potentiel : Relance promo</span>
      </Typography>
    </Box>
    <Box>
      <Typography sx={{ fontWeight: 600, color: '#43a047', fontSize: 15 }}>
        ● Prospects Qualifiés
      </Typography>
      <Typography sx={{ color: '#495057', fontSize: 14 }}>
        Conversion en hausse, taux de clic 4%. <br />
        <span style={{ color: '#e57373', fontWeight: 600 }}>Potentiel : Activation</span>
      </Typography>
    </Box>
    <Box mt="auto" pt={2}>
      <Link href="/segment" sx={{ color: '#1976d2', fontWeight: 600, fontSize: 15, textDecoration: 'underline' }}>
        Voir tous les segments
      </Link>
    </Box>
  </Box>
);

export default TopSegmentsCard;
